import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Dashboard.css';
import { API_URL } from '../config/api';

const Dashboard = ({ user, phoneId }) => {
  const [stats, setStats] = useState({
    totalItems: 0,
    totalUsers: 0,
    totalScans: 0,
    availableItems: 0,
    pendingRequests: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [itemsRes, usersRes, scansRes, requestsRes] = await Promise.all([
        fetch(`${API_URL}/api/items`),
        fetch(`${API_URL}/api/users`),
        fetch(`${API_URL}/api/scans`),
        fetch(`${API_URL}/api/requests?status=pending`)
      ]);

      const items = await itemsRes.json();
      const users = await usersRes.json();
      const scans = await scansRes.json();
      const requests = await requestsRes.json();

      const availableItems = items.reduce((sum, item) => sum + item.stock_quantity, 0);

      setStats({
        totalItems: items.length,
        totalUsers: users.length,
        totalScans: scans.length,
        availableItems: availableItems,
        pendingRequests: requests.length
      });
    } catch (error) {
      console.error('Erreur lors du chargement des statistiques:', error);
    }
  };

  return (
    <div className="dashboard">
      <h1>Tableau de bord</h1>

      {user && (
        <div className="welcome-card card">
          <h2>Bienvenue, {user.name}!</h2>
          <p>Vous êtes identifié automatiquement via votre appareil.</p>
          <p className="phone-id">ID Appareil: {phoneId?.substring(0, 20)}...</p>
        </div>
      )}

      <div className="stats-grid">
        <div className="stat-card card">
          <h3>Éléments en stock</h3>
          <p className="stat-number">{stats.totalItems}</p>
        </div>
        <div className="stat-card card">
          <h3>Éléments disponibles</h3>
          <p className="stat-number">{stats.availableItems}</p>
        </div>
        <div className="stat-card card">
          <h3>Utilisateurs</h3>
          <p className="stat-number">{stats.totalUsers}</p>
        </div>
        <div className="stat-card card">
          <h3>Total scans</h3>
          <p className="stat-number">{stats.totalScans}</p>
        </div>
        <div className="stat-card card">
          <h3>Demandes en attente</h3>
          <p className="stat-number">{stats.pendingRequests}</p>
        </div>
      </div>

      <div className="quick-actions card">
        <h2>Actions rapides</h2>
        <div className="actions-grid">
          <Link to="/scan" className="action-btn btn btn-primary">
            Scanner un QR Code
          </Link>
          <Link to="/stock" className="action-btn btn btn-success">
            Gérer le stock
          </Link>
          <Link to="/requests" className="action-btn btn btn-warning">
            Gérer les demandes {stats.pendingRequests > 0 && `(${stats.pendingRequests})`}
          </Link>
          <Link to="/users" className="action-btn btn btn-secondary">
            Voir les utilisateurs
          </Link>
          <Link to="/planif-sync" className="action-btn btn btn-info">
            🔄 Synchroniser Planif
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

